<div class="persisted-files-section"
     [class.drag-over]="isDragOver"
     (dragenter)="onDragEnter($event)"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)">

  <!-- === OVERLAY (Appears only when dragging) === -->
  <div class="drag-overlay">
    <div class="overlay-content">
      <i class="fa fa-cloud-upload fa-3x mb-3"></i>
      <h3>Drop files to upload</h3>
      <p>Directories are supported</p>
    </div>
  </div>

  <div class="upload-control-bar" (click)="triggerFileInput()">
    <div class="d-flex align-items-center justify-content-center gap-2 content-wrapper">
      <i class="fa fa-cloud-upload text-muted mr-1"></i>
      <span class="text-muted small">Drop files here or</span>
      <input type="file" #fileInput multiple (change)="onFileSelected($event)" [accept]="allowedFileExtensions.join(',')" style="display: none;">
      <button class="btn btn-primary btn-sm ml-1" [disabled]="isLoading">
        <i class="fa fa-upload me-1"></i> Upload
      </button>
      <button *ngIf="visibleFiles.length > 0" class="btn btn-sm btn-outline-success ml-1" (click)="onIndexAllRequested($event)">
        Index All
      </button>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="text-center p-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-2 text-muted small">Syncing documents...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error && !isLoading" class="alert alert-warning alert-sm shadow-sm" role="alert">
    <i class="fa fa-exclamation-triangle me-1"></i> {{ error }}
  </div>

  <!-- File List -->
  <ul *ngIf="!isLoading && visibleFiles.length > 0" class="list-group document-list">
    <li *ngFor="let file of visibleFiles; let i = index"
        class="list-group-item d-flex justify-content-between align-items-center flex-wrap gap-2"
        [ngClass]="{
          'clickable-row': file.status === 'Success' && file.id,
          'list-group-item-primary active-filter-row': activeFilterFileId === file.id
        }"
        (click)="onFilterByRow(file, $event)">

      <!-- File Info -->
      <div class="me-auto">
        <span class="file-name me-2 mr-1">{{ file.name }}</span>

        <!-- Indexing Badge -->
        <span *ngIf="file.status === 'Indexing'" class="badge badge-indexing ms-2">
          <i class="fa fa-cog fa-spin me-1"></i> Indexing...
        </span>
        <small class="text-muted">({{ file.timestamp | date:'shortTime' }})</small>
        <span *ngIf="activeFilterFileId === file.id" class="badge bg-primary ms-2">
          <i class="fa fa-filter me-1"></i> Filtering KIs
        </span>
        <div *ngIf="file.message" class="file-message small mt-1"
             [ngClass]="{
                'text-danger': file.status === 'Error',
                'text-success': file.status === 'Success',
                'text-info': file.status === 'Saving' || file.status === 'Indexing',
                'text-muted': file.status === 'Uploading' || file.status === 'Loading'
             }">
          <!-- Update Icon Logic -->
          <i *ngIf="file.status === 'Saving' || file.status === 'Uploading' || file.status === 'Indexing'" class="fa fa-spinner fa-spin me-1"></i>
          {{ file.message }} by <i class="fa fa-user-circle-o me-1"></i> {{ file.uploadedBy }}
        </div>
      </div>

      <!-- File Actions & Status -->
      <div class="d-flex align-items-center">

        <!-- Embedding Status -->
        <div class="embedding-status me-3 mr-3" *ngIf="file.status === 'Success'">
          <span *ngIf="file.isEmbedded" class="text-success d-flex align-items-center"
                title="Status: Embedded & Indexed for AI Context">
            <i class="fa fa-database me-1 mr-1"></i>
            <span class="small fw-bold" style="font-size: 0.75rem;">Indexed</span>
          </span>
          <span *ngIf="!file.isEmbedded" class="text-warning d-flex align-items-center"
                title="Status: Not yet embedded (Not visible to AI search)">
            <i class="fa fa-database me-1 opacity-50 mr-1"></i>
            <span class="small text-muted" style="font-size: 0.75rem;">Not Indexed</span>
          </span>
        </div>


        <!-- View Button -->
        <button *ngIf="file.status === 'Success'"
                class="btn btn-sm btn-outline-info mr-2 ms-2"
                title="View Content"
                (click)="onViewFile(file, $event)">
          <i class="fa fa-eye"></i> View
        </button>

        <!-- Delete Button -->
        <button *ngIf="file.id"
                class="btn btn-sm btn-link-danger"
                title="Delete File Record"
                [disabled]="file.status === 'Deleting'"
                (click)="deletePersistedFile(file, $event)">
          <i class="fa fa-trash"></i>
        </button>

        <!-- Status Badge (only for non-success, non-indexing states) -->
        <span *ngIf="file.status !== 'Success' && file.status !== 'Indexing'" class="badge badge-status"
              [ngClass]="{'badge-error': file.status === 'Error',
                          'badge-warning': file.status === 'Deleting',
                          'badge-muted': file.status === 'Saving' || file.status === 'Uploading' || file.status === 'Loading'}">
          <i *ngIf="file.status === 'Uploading' || file.status === 'Saving' || file.status === 'Deleting'" class="fa fa-spinner fa-spin me-1"></i>
          <i *ngIf="file.status === 'Error'" class="fa fa-exclamation-triangle me-1"></i>
          {{ file.status }}
        </span>
      </div>
    </li>
  </ul>

  <!-- Empty state hidden — upload bar is self-explanatory -->

</div>
